// pl_pms_live_board.ts
// Tłumaczenia dla PMS.LiveBoard.Dashboard.tsx

export const plPmsLiveBoard = {

  title: "Panel operacyjny",
  managerView: "Panel menedżera",
  newReservation: "Nowa rezerwacja",
  today: "Dziś",

  // ── Kafelki główne ───────────────────────────────────────────────────────
  tiles: {
    occupancySold: "Obłożenie (sprzedane na dzisiejszą noc)",
    inHouseNow: "Goście w hotelu (obecnie)",
    readyToSell: "Gotowe do sprzedaży",
    soldTonight: "Sprzedane na dzisiejszą noc: {{occupied}} / {{sellable}} dostępnych pokoi",
    notAvailable: "Brak danych",
    ofTotal: "{{percent}}% wszystkich",
    needsActionWithRoutine: "Wymaga działania · {{count}} rutynowych statusów",
    inHouseNowHint: "Goście obecnie w hotelu, w tym wyjeżdżający dzisiaj",
    occupancy: "Obłożenie",
    arrivals: "Przyjazdy",
    departures: "Wyjazdy",
    inHouse: "Goście w obiekcie",
    readyRooms: "Pokoje gotowe",
    openIssues: "Otwarte zgłoszenia",
  },

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    housekeeping: "Służba pięter",
    frontDesk: "Recepcja",
    billing: "Rozliczenia",
  },

  // ── Przyciski operacji ───────────────────────────────────────────────────
  actions: {
    checkIn: "Zamelduj",
    checkInNow: "Zamelduj teraz",
    checkOut: "Wymelduj",
    confirmCheckIn: "Potwierdź zameldowanie",
    confirmCheckOut: "Potwierdź wymeldowanie",
    confirmMove: "Potwierdź zmianę pokoju",
    earlyCheckIn: "Wcześniejsze zameldowanie",
    lateCheckOut: "Późniejsze wymeldowanie",
    roomMove: "Zmiana pokoju",
    walkIn: "Gość bez rezerwacji",
    approve: "Zatwierdź",
    addNote: "Dodaj notatkę",
    saveNote: "Zapisz notatkę",
  },

  // ── Notatka ──────────────────────────────────────────────────────────────
  noteQuestion: "Jakie informacje powinny zostać przekazane zespołom?",

  // ── Statusy i wyniki akcji ───────────────────────────────────────────────
  messages: {
    checkInSuccessful: "Gość został pomyślnie zameldowany.",
    checkInFailed: "Nie udało się zameldować gościa.",
    checkOutSuccessful: "Gość został pomyślnie wymeldowany.",
    checkOutFailed: "Nie udało się wymeldować gościa.",
    checkInNotPossible: "Zameldowanie przed datą przyjazdu nie jest możliwe.",
    lateCheckoutFailed: "Nie udało się ustawić późniejszego wymeldowania.",
    lateCheckoutUntil: "Późniejsze wymeldowanie do ",
    roomMoveCompleted: "Zmiana pokoju została zakończona.",
    roomMoveFailed: "Nie udało się zmienić pokoju.",
    roomMovePrefix: "Zmiana pokoju: ",
    noteAdded: "Notatka została dodana.",
    failedToAddNote: "Nie udało się dodać notatki.",
    alertDismissed: "Powiadomienie zostało zamknięte.",
    approved: "Zatwierdzono",
    approvedFromLiveBoard: "Zatwierdzono z panelu operacyjnego.",
    paymentPosted: "Płatność została zaksięgowana.",
    chargePosted: "Opłata została zaksięgowana.",
    housekeepingTaskCreated: "Utworzono zadanie dla służby pięter.",
    incidentResolved: "Zgłoszenie zostało rozwiązane.",
    reservationCreated: "Rezerwacja została utworzona.",
    walkInCheckedIn: "Zameldowano gościa bez rezerwacji: ",
    walkInFailed: "Nie udało się zameldować gościa bez rezerwacji.",
    walkInReservationCreated: "Utworzono rezerwację dla gościa bez rezerwacji.",
    roomStatusUpdated: "Status pokoju został zaktualizowany.",
    failedToUpdateRoom: "Nie udało się zaktualizować danych pokoju.",
    failedToUpdateRoomStatus: "Nie udało się zaktualizować statusu pokoju.",
    failedToUpdateIncident: "Nie udało się zaktualizować zgłoszenia.",
    failedToAssign: "Nie udało się przypisać.",
    noPropertySelected: "Nie wybrano obiektu.",
    noPendingArrivals: "Brak oczekujących przyjazdów.",
    noPendingDepartures: "Brak oczekujących wyjazdów.",
    needsAction: "Wymaga działania",
  },

  // ── Etykiety tabelki/kart ─────────────────────────────────────────────────
  labels: {
    floor: "Piętro ",
    room: "Pokój ",
    guest: "Gość",
    guestsNow: "Liczba gości",
    fullName: "Imię i nazwisko",
    standard: "Standard",
    nights: "Liczba nocy",
  },

} as const;

export default plPmsLiveBoard;
